import { render, staticRenderFns } from "./QuotationEmailItem.vue?vue&type=template&id=4fd81ea2&scoped=true&"
import script from "./QuotationEmailItem.vue?vue&type=script&lang=js&"
export * from "./QuotationEmailItem.vue?vue&type=script&lang=js&"
import style0 from "./QuotationEmailItem.vue?vue&type=style&index=0&id=4fd81ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd81ea2",
  null
  
)

export default component.exports